
import { Component, Vue } from "vue-property-decorator";
import axios from "axios";
import { CDataTableFields } from "@/@types";
import { authTokenStorage } from "@/auth/AuthTokenStorage";

interface Payout {
  id: string;
  amount: number;
  status: string;
  arrival_date_mst_formatted: string;
}

interface PayoutResponse {
  success: boolean;
  payouts: Payout[];
}

@Component({
  components: { }
})
export default class StripePayoutsListHandler extends Vue {
  payouts: Payout[] = [];
  loading = false;

  fields: CDataTableFields = [
    { key: "amount", label: "Amount", filter: false, sorter: true },
    { key: "status", label: "Status", filter: false, sorter: true },
    { key: "arrive_by", label: "Arrive By", filter: false, sorter: true },
  ];

  async mounted() {
    await this.fetchPayouts();
  }

  async fetchPayouts() {
    this.loading = true;
    try {
      const token = await authTokenStorage.getAccessToken();
      const response = await axios.get<PayoutResponse>(
        "https://payments.api.kbmercury.com/stripe/payout/list",
        {
          headers: {
            Authorization: token ? `Bearer ${token}` : undefined,
          },
        }
      );

      if (response.data.success && response.data.payouts) {
        this.payouts = response.data.payouts;
      }
    } catch (error) {
      console.error("Error fetching payouts:", error);
    } finally {
      this.loading = false;
    }
  }

  formatAmount(amount: number): string {
    // Format as $ + number_format(amount * 100, 2)
    // PHP number_format adds thousand separators and 2 decimal places
    const value = amount / 100;
    const formatted = value.toLocaleString('en-US', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    });
    return `$${formatted}`;
  }

  formatStatus(status: string): string {
    if (!status) return '';
    
    // Remove underscores and replace with spaces
    const text = status.replace(/_/g, ' ');
    
    // Convert first word to uppercase, rest to lowercase
    const words = text.split(' ');
    if (words.length > 0) {
      words[0] = words[0].charAt(0).toUpperCase() + words[0].slice(1).toLowerCase();
      // Keep remaining words in their original case or make them lowercase
      for (let i = 1; i < words.length; i++) {
        words[i] = words[i].toLowerCase();
      }
    }
    
    return words.join(' ');
  }

  getStatusColor(status: string): string {
    if (!status) return 'secondary';
    
    const normalizedStatus = status.toLowerCase();
    
    if (normalizedStatus === 'in_transit' || normalizedStatus === 'in transit') {
      return 'info'; // Light blue
    }
    
    if (normalizedStatus === 'paid') {
      return 'success'; // Green
    }
    
    return 'secondary'; // Gray for any other status
  }

  onRowClick(item: Payout) {
    this.$router.push(`/payment/stripe-payouts/${item.id}`);
  }
}
